import { type SocketMachineContext } from '../../network-state-machine-context';

export function onExitActive<
  T extends Pick<SocketMachineContext, 'pendingMessages' | 'transport'>,
>(ctx: T) {
  ctx.pendingMessages.setPredicate(() => false);

  ctx.transport?.dispose();
  ctx.transport = undefined;
}
